import { createContext } from "react";

export const ProjectManagerContext = createContext(false);
